module.exports = __webpack_public_path__ + "officialStatic/img/x-cases.1ebfb2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/x-cases.png
// module id = HxBS
// module chunks = 0